import { AxiosError } from 'axios';

/**
 * Reducer for the global application context.
 * @type {AppReducer} appReducer
 */
export default function appReducer(state, action) {
  switch (action.type) {
    // AUTH REDUCERS
    case 'SET_AUTHENTICATION': {
      if (action.payload?.token && !state.auth?.token) {
        window.location.replace('/');
      }
      return { ...state, auth: action.payload };
    }

    case 'SET_USER': {
      return { ...state, user: action.payload };
    }

    case 'DELETE_AUTHENTICATION': {
      return { ...state, auth: undefined, user: undefined };
    }

    default: {
      throw new AxiosError('', `Unhandled action type: ${action.type}`);
    }
  }
}
